import PAGE from "@/components/page/lang/lang-vn";
import EMG from "@/views/emg/lang/lang-vn";
import BUSINESS from "@/views/business/lang/lang-vn";
export const login = {
  login: 'Đăng nhập',
  choiceProject: "Xin chọn dự án",
  choiceLang: "Xin chọn ngôn ngữ",
  password: 'Mật khẩu',
}
export const common = {
  edit: 'Biên soạn',
  add: 'Thêm',
  delete: 'Xóa',
  copy: 'sao chép',
  date: 'Thời gian',
  remark: 'Ghi chú',
  handle: 'Thao tác',
  stop: 'Ngừng dùng',
  start: 'Khởi dùng',
  search: 'Tra cứu',
  reset: 'Đặt lại',
  nodata: 'Tạm không có dữ liệu',
  cancel: 'Hủy',
  ok: 'Xác nhận',
  addNew: 'Thêm',
  layOut: 'Thoát khỏi',
  status: 'Trạng thái',
  tip: 'Lưu ý',
  import: "Nhập khẩu",
  export: "xuất",
  detail: "Chi tiết",
  ifDelete: 'Có chắc xóa đi không',
  conDelete: 'Xóa thành công',
  canDele: 'Đã hủy xóa',
  ifStatus: 'Bị vô hiệu hóa?',
  ifStatus1: '是否启用?',
  conStatus: "Được kích hoạt!",
  conStatus1: "Cho phép thành công!",
  canStatus: "Hủy bỏ!",
  changeSu: 'Sửa lại thành công',
  addSu: 'Thêm thành công',
  autoSend: 'Gửi tự động',
  timeSend: 'Gửi đúng giờ',
  otherMessage: 'Những loại tin nhắn thông báo khác',
  verification: 'Mã xác thực',
  rulesText: '内容不能为空',
  trackerAuth: "用户追踪授权",
  startTime:"Thời gian bắt đầu",
  endTime:"Thời gian kết thúc",
}
export const menu = {
  chName: 'Tên tiếng Trung',
  enName: 'Tên tiếng Anh',
  vnName: 'Tên tiếng Việt',
  component: 'Tên đơn vị',
  pathName: 'Đường lối phỏng vấn',
  choiceIcon: 'Chọn hình tượng',
  comPath: 'Đường lối đơn vị',
  icon: 'Hình tượng',
  sort: 'Số xếp hạng',
  editMenu: 'Biên soạn menu',
  addMenu: 'Thêm menu',
}
export const role = {
  addRole: 'Thêm vai trò',
  role: 'Vai trò',
  editRoleName: 'Biên soạn vai trò',
  roleName: 'Tên vai trò',
  menuControl: 'Quyền hạn menu',
  columnAuth: 'Quyền hạn cột',
}
export const user = {
  addUser: 'Thêm người dùng',
  user: 'Người dùng',
  editUserName: 'Biên soạn người dùng',
  companyChoice: 'Chọn công ty',
  roleChoice: 'Chọn vai trò',
  businessChoice: 'Chọn nhiệm vụ',
  nickName: 'Tên hiệu',
  loginName: 'Tên đăng nhập',
  email: 'Email',
  phone: 'Số điện thoại',
  userStatus: 'Trạng thái người dùng',
  resetPass: 'Đặt lại mật khẩu'
}
export const whiteList = {
  synchronism: 'Đồng bộ',
  platFormName: 'Tên sàn',
  modules: 'Bộ phận',
  domain: 'Tên miền',
  gateWay: 'Cổng vào',
}
export const company = {
  companyName: 'Tên nghiệp vụ',
  bandGate: 'Liên kết cổng vào',
  resetKey: 'Đặt lại key',
  businessChioce: 'Chọn nghiệp vụ',
  businessHolder: 'Xin chọn nghiệp vụ'
}
export const job = {
  jobName: 'Tên nhiệm vụ',
  jobClass: 'Chia nhóm nhiệm vụ',
  jobDes: 'Miêu tả nhiệm vụ',
  jobDo: ' Loại thực hiện nhiệm vụ',
  cron: 'cron Hình thức bày tỏ',
  wait: 'Chờ đợi',
  pause: 'Tạm dừng',
  executed: 'Thực hành bình thường',
  block: 'ùn tắc',
  error: 'Lỗi',
  startOff: 'Xuất phát',
  pauseJob: 'Tạm dừng nhiệm vụ',
  backJob: 'Khôi phục nhiệm vụ',
  confimStart: 'Bạn có chắc kích hoạt nhiệm vụ này',
  startSucc: 'Kích hoạt thành công'
}
export const message = {
  messageClass: ' Loại tin nhắn',
  type: ' Loại hình',
  moduleCode: ' Khuôn code',
  content: 'Nội dung',
  ipLimit: ' Giới hạn ip',
  phoneLimit: 'Giới hạn điện thoại',
  time: 'Thời gian chỉ định',
  sendType: 'Loại hình gửi',
  ipHolder: ' 1 IP có thể gửi bao nhiêu lần tin nhắn xác thực trong 1 ngày',
  phoneHolder: '1 chiếc điện thoại có thể gửi bao nhiêu lần tin nhắn xác thực trong 1 ngày ',
  timeHolder: 'Gửi tin nhắn có hạn chế thời gian chỉ định không( Mặt định có hiệu trong 60 giây)',
}
export const gateWay = {
  programId: ' ID dự án',
  programName: 'Tên dự án',
  predicates: 'predicates',
  gateUri: ' Cổng vào Uri ',
  Gateway: ' Cổng vào ',
}
export const thisCompany = {
  companyName: 'Tên công ty',
  companyCode: 'Mã của công ty',
  loginName: 'Tên đăng nhập',
  niceName: 'Tên hiệu người dùng',
  phone: ' Số điện thoại'
}
export const menuName = {
  home: ' Trang chủ',
  sysName: 'Quản lý hệ thống',
  menuManage: 'Quản lý Menu',
  userManage: ' Quản lý người dùng',
  whiteManage: ' Quản lý danh sách trắng',
  compangManage: ' Quản lý công ty',
  jobManage: 'Quản lý nhiệm vụ',
  messageManage: ' Quản lý tin nhắn',
  gateWayManage: ' Quản lý cổng vào',
  businessManage: ' Quản lý nghiệp vụ',
  myCompany: 'Công ty của tôi',
  companyBasic: 'Thông tin cơ bản của công ty'
}

export const page = PAGE;
export const business = BUSINESS;
export const emg = EMG;
